export const IMG_EXTENSIONS = ['jpg', 'jpeg', 'png', 'gif'];
